import GoBackButtonIcon from '@/assets/icons/GoBackButtonIcon';
import { business } from '@/routes/config';
import { Box, Typography, useTheme } from '@mui/material';
import { useGetRetrieveChunk } from 'apis/business/setting/knowledgeBase/hook';
import Button from 'components/Common/Button';
import Input from 'components/Common/Input';
import { useBusiness } from 'providers/context/BusinessProvider';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useParams } from 'react-router-dom';

export default function RetrievalTesting({ isRenderInModal = false }: { isRenderInModal?: boolean }) {
  const theme = useTheme();
  const { knowledgeBaseId } = useParams();
  const { selectedLocation } = useBusiness();
  const [submitted, setSubmitted] = useState<any | null>(null);
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      similarity_threshold: 0.2,
      vector_similarity_weight: 0.3
    }
  });

  const { data: retrieveChunk } = useGetRetrieveChunk(submitted, {
    queryKey: ['retrieveChunk', selectedLocation, knowledgeBaseId, submitted],
    enabled: Boolean(selectedLocation && knowledgeBaseId && submitted)
  });

  const onSubmit = (data?: any) => {
    setSubmitted(data ?? watch());
  };

  return (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='center' marginBottom={3}>
        <Box display='flex' alignItems='center' gap={1}>
          <Link style={{ lineHeight: 0 }} to={`${business.base}/${business.KnowledgeBases}`}>
            <GoBackButtonIcon />
          </Link>
          <Typography variant='h6'>Retrieval Testing</Typography>
        </Box>
      </Box>
      <Box
        bgcolor={theme.palette.background.paper}
        padding={3}
        borderRadius='8px'
        border={'1px solid #ececec'}
        component='form'
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input name='content' label='Test Text' control={control} fullWidth />
        <Button onClick={() => onSubmit()} sx={{ marginTop: '24px', display: 'block', marginLeft: 'auto' }}>
          Testing
        </Button>
      </Box>
      <Box height={isRenderInModal ? '300px' : '100%'} overflow='auto'>
        {retrieveChunk?.data?.map((chunk: any, index: number) => (
          <Box
            key={index}
            bgcolor={theme.palette.background.paper}
            padding={3}
            borderRadius='4px'
            marginTop={3}
            gap={0.5}
          >
            <Box border='1px solid #ECECEC' padding={3} borderRadius={0.5} mt={3} key={index}>
              <Box display='flex' alignItems='center' gap={3} borderBottom='1px solid #ECECEC' pb={3}>
                <Typography>{(chunk?.similarity * 100)?.toFixed(2)} Hybrid Similarity</Typography>
                <Typography>{(chunk?.term_similarity * 100)?.toFixed(2)} Term Similarity</Typography>
                <Typography>{(chunk?.vector_similarity * 100)?.toFixed(2)} Vector Similarity</Typography>
              </Box>
              <Box display='flex' gap={3} mt={3}>
                <Typography sx={{ wordBreak: 'break-word' }}>{chunk?.content_with_weight}</Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
}
